import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { ILocation } from "../../../../interfaces/user";
import { IPartnerStore } from "../../../../interfaces/store";

interface IProps {
  userLocationList?: ILocation[];
  selectedStore: IPartnerStore;
  selectedLocationKey: number;
  handleComboChange: (event: SelectChangeEvent) => void;
  partnerStoreId: string;
}

const SelectCombo: React.FC<IProps> = ({
  userLocationList,
  selectedLocationKey,
  handleComboChange,
  partnerStoreId,
  selectedStore,
}): JSX.Element => {
  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl key={partnerStoreId} fullWidth>
        <InputLabel id={partnerStoreId}>Select Location</InputLabel>
        <Select
          labelId={partnerStoreId}
          id={partnerStoreId}
          value={
            selectedStore.PartnerStoreId === partnerStoreId
              ? selectedLocationKey.toString()
              : ""
          }
          label="Location"
          onChange={handleComboChange}
        >
          {userLocationList &&
            userLocationList.map((location: ILocation) => (
              <MenuItem value={location.LocationId}>
                {location.LocationName}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectCombo;
